import React from 'react'
import ReactDOM from 'react-dom/client'
import './scss/global.scss'
import { BrowserRouter, Navigate, Routes, Route, useLocation } from 'react-router-dom'
import App from './App'
import { ROUTES } from './lib/constants'
import { ScrollToTop } from './components/ScrollToTop'
import { LandingPage } from './pages/LandingPage/LandingPage'
import { NotFound } from './pages/NotFound/NotFound'
import reportWebVitals from './reportWebVitals'
import { ConnectAndControl } from './pages/ConnectAndControl/ConnectAndControl'
import { WorkHardPlayHard } from './pages/WorkHardPlayHard/WorkHardPlayHard'
import { EverythingEverywhere } from './pages/EverythingEverywhere/EverythingEverywhere'
import { GigInternet } from './pages/GigInternet/GigInternet'
import { Blog } from './pages/Blog/Blog'
import { BlogArticle } from './pages/BlogArticle/BlogArticle'
import { ApartmentProjects } from './pages/ApartmentProjects/ApartmentProjects'
import { HOAProjects } from './pages/HOAProjects/HOAProjects'
import { AboutUs } from './pages/AboutUs/AboutUs'
import { AboutFiber } from './pages/AboutFiber/AboutFiber'
import { ReferralProgram } from './pages/ReferralProgram/ReferralProgram'
import { JoinOurTeam } from './pages/JoinOurTeam/JoinOurTeam'
import { Construction } from './pages/Construction/Construction'
import { CurrentServiceAreas } from './pages/CurrentServiceAreas/CurrentServiceAreas'
import { Streaming } from './pages/Streaming/Streaming'
import { BusinessSolutions } from './pages/BusinessSolutions/BusinessSolutions'
import { WebsiteTerms } from './pages/LegalPages/WebsiteTerms'
import { ResidentialTerms } from './pages/LegalPages/ResidentialTerms'
import { CommercialTerms } from './pages/LegalPages/CommercialTerms'
import { PrivacyPolicy } from './pages/LegalPages/PrivacyPolicy'
import { Policies } from './pages/LegalPages/Policies'
import { AcceptableUsePolicy } from './pages/LegalPages/AcceptableUsePolicy'
import { BetaAgreement } from './pages/LegalPages/BetaAgreement'
import { DMCAPolicy } from './pages/LegalPages/DMCAPolicy'
import { TextMessagingTerms } from './pages/LegalPages/TextMessagingTerms'

import CheckAvailabilityPage from './pages/CheckAvailabilityPage/CheckAvailabilityPage'
import ContactUs from './pages/ContactUs/ContactUs'

const RedirectToBusiness = (): React.JSX.Element => {
  const { hash, search } = useLocation()
  const nextHash = hash === '#smartbiz-form' ? '#business-inquiry-form' : hash
  return (
    <Navigate
      to={`${ROUTES.businessSolutions.path}${search}${nextHash}`}
      replace
    />
  )
}

const baseUrl: string =
  document.getElementsByTagName('base')[0]?.getAttribute('href') || '/'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter basename={baseUrl}>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<LandingPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path={ROUTES.checkAvailability.path} element={<CheckAvailabilityPage />} />
            {/* Packages */}
            <Route path={ROUTES.gigInternet.path} element={<GigInternet />} />
            <Route
              path={ROUTES.connectAndControl.path}
              element={<ConnectAndControl />}
            />
            <Route
              path={ROUTES.workHardPlayHard.path}
              element={<WorkHardPlayHard />}
            />
            <Route
              path={ROUTES.everythingAndEverywhere.path}
              element={<EverythingEverywhere />}
            />
            {/* Business Solutions */}
            <Route
              path={ROUTES.businessSolutions.path}
              element={<BusinessSolutions />}
            />
            <Route path={ROUTES.smartBiz.path} element={<RedirectToBusiness />} />
            <Route path="/business-solutions" element={<RedirectToBusiness />} />
            {/* Community */}
            <Route
              path={ROUTES.apartmentProjects.path}
              element={<ApartmentProjects />}
            />
            <Route path={ROUTES.hoaProjects.path} element={<HOAProjects />} />
            {/* About */}
            <Route path={ROUTES.aboutUs.path} element={<AboutUs />} />
            <Route path={ROUTES.aboutFiber.path} element={<AboutFiber />} />
            <Route
              path={ROUTES.referralProgram.path}
              element={<ReferralProgram />}
            />
            <Route path={ROUTES.joinOurTeam.path} element={<JoinOurTeam />} />
            <Route path={ROUTES.construction.path} element={<Construction />} />
            <Route
              path={ROUTES.currentServiceAreas.path}
              element={<CurrentServiceAreas />}
            />
            <Route path={ROUTES.streaming.path} element={<Streaming />} />
            {/* Blog */}
            <Route path={ROUTES.blog.path} element={<Blog />} />
            <Route path={ROUTES.blog.altPath} element={<Blog />} />
            <Route path={ROUTES.blogArticle.path} element={<BlogArticle />} />
            {/* Legal */}
            <Route path={ROUTES.policies.path} element={<Policies />} />
            <Route path={ROUTES.websiteTerms.path} element={<WebsiteTerms />} />
            <Route
              path={ROUTES.residentialTerms.path}
              element={<ResidentialTerms />}
            />
            <Route
              path={ROUTES.commercialTerms.path}
              element={<CommercialTerms />}
            />
            <Route path={ROUTES.privacy.path} element={<PrivacyPolicy />} />
            <Route path={ROUTES.aup.path} element={<AcceptableUsePolicy />} />
            <Route
              path={ROUTES.betaAgreement.path}
              element={<BetaAgreement />}
            />
            <Route path={ROUTES.dmcaPolicy.path} element={<DMCAPolicy />} />
            <Route
              path={ROUTES.textMessagingTerms.path}
              element={<TextMessagingTerms />}
            />

            {/* Contact */}
            <Route path={ROUTES.contactUs.path} element={<ContactUs />} />
          </Route>
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
